import React, { useState } from "react";
import { FileDown, FileSpreadsheet } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { downloadFile } from "@/components/shipment/ReportButtons";
import { Panel } from "./shared";

const thisMonth = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const ReportDownloads = ({ report, month = "" }) => (
  <div className="flex gap-2">
    {[["pdf", FileDown, "PDF"], ["xlsx", FileSpreadsheet, "Excel"]].map(([fmt, Icon, label]) => (
      <Button key={fmt} data-testid={`download-${report}-${fmt}`} size="sm" variant="outline" className="border-slate-700 hover:bg-slate-800"
              onClick={() => downloadFile(`/finance/reports/${report}.${fmt}${month ? `?month=${month}` : ""}`, `${report}-${month || "all"}.${fmt}`)}>
        <Icon size={14} className="mr-1" /> {label}
      </Button>
    ))}
  </div>
);

const REPORTS = [
  ["vat-summary", "VAT Summary", "VATable, output VAT, zero-rated, non-VAT, discounts, input VAT, withholding and net collections"],
  ["invoices", "Invoices", "Every invoice issued in the month with its VAT breakdown"],
  ["collections", "Collections", "Collections with deductions withheld and net received"],
  ["payables", "Accounts Payable", "Quotations and supplier invoices with input VAT and balances"],
];

export default function FinanceReports() {
  const [month, setMonth] = useState(thisMonth());
  return (
    <Panel title="VAT Summary & Reports" subtitle="Pick a month (or clear it for all dates) and download any report as PDF or Excel."
           right={<Input data-testid="input-finance-report-month" type="month" value={month} onChange={(e) => setMonth(e.target.value)}
                         style={{ colorScheme: "dark" }} className="w-44 bg-slate-950 border-slate-700" />}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {REPORTS.map(([k, title, hint]) => (
          <div key={k} data-testid={`report-card-${k}`} className="bg-slate-950/50 border border-slate-800 rounded-md p-4 flex flex-col gap-3">
            <div><div className="font-display font-bold">{title}</div><div className="text-xs text-slate-500">{hint}</div></div>
            <ReportDownloads report={k} month={month} />
          </div>
        ))}
      </div>
    </Panel>
  );
}
